import { Locale, K } from "../constants";

const locale: Locale = {
  [K.AGENT_STATUS_NORMAL]: "Normal",
  [K.AGENT_STATUS_ABNORMAL]: "Abnormal",
  [K.AGENT_STATUS_NOT_INSTALLED]: "Not Installed",
  [K.AGENT_STATUS_UNINSTALLED]: "Uninstalled",
  [K.AGENT_STATUS_UNDER_MAINTENANCE]: "Under Maintenance",
  [K.ALERT_MSG_SENDED]: "Alert Message Sended",
  [K.ALERT_CONVERGED]: "Alert Converged",
  [K.ALERT_RECOVERED]: "Alert Recovered",
  [K.ALERT_MANUAL_RECOVERED]: "Alert Recovered Manually",
  [K.ALERT_SHIELDED]: "Alert Shielded",
  [K.PRESENTATIONAL_BRICKS]: "Presentational Bricks",
  [K.PAGINATION_TOTAL_TEXT]: "Total",
  [K.PAGINATION_TOTAL_UNIT]: "items",
  [K.UNKNOWN_ERROR]: "unknown error",
  [K.NO_DATA]: "No Data",
  [K.COLLECTION_INSTANCE_SYNCHRONIZE]: "Synchronize",
  [K.COLLECTION_INSTANCE_EXECUTE]: "Execute",
  [K.DELETE]: "Delete",
  [K.CROP_TITLE]: "Crop your new profile picture",
  [K.COPY]: "Copy",
  [K.COPY_FAILED]: "Copy Failed",
  [K.COPIED]: "Copied",
  [K.NO_TEXT_TO_COPY]: "No text to copy",
  [K.CHOSEN_OPTIONS]: "Chosen {{count}} Options",
  [K.CLEAR]: "Clear",
  [K.SELECTED]: "Selected",
  [K.SELECT_ALL]: "Select all",
  [K.ITEMS]: "options",
  [K.SELECTED_OPTIONS]: "Selected {{number}} Options",
  [K.FULL_TEXT_SEARCH]: "Fulltext Search",
  [K.IP_SEARCH]: "IP Search ",
  [K.SORT]: "Sort",
  [K.PREVIEW]: "Preview",
  [K.NO_ALERT]: "Don't show again",
  [K.EDIT]: "Edit",
  [K.COPY_CODE]: "Copy Code",
  [K.CODE_COPIED]: "Code copied to clipboard",
  [K.CODE_COPY_FAILED]: "Copy failed, please copy manually",
  [K.CLUSTER_TYPE_NONE]: "None",
  [K.CLUSTER_TYPE_DEVELOPMENT]: "Development",
  [K.CLUSTER_TYPE_TEST]: "Test",
  [K.CLUSTER_TYPE_PRODUCTION]: "Production",
  [K.CLUSTER_TYPE_PRE_RELEASE]: "Pre-production",
  [K.PLEASE_ENTER_THE_SEARCH_CONTENT]: "Please enter the search content",
  [K.COUNT_ITEMS]: "{{count}} items",
  [K.EXPAND]: "Expand",
  [K.COLLAPSE]: "Collapse",
  [K.TIP]: "Tip",
  [K.MAX_SELECTED_EXCEEDED]: "The number of selections exceeds the maximum limit ({{max}}), please reselect",
  [K.GOT_IT]: "Got it",
  [K.MAX_SELECT_COUNT]: "Select up to {{max}} items",
  [K.ACTIONS]: "Actions",
  [K.CONFIRM]: "Confirm",
  [K.CANCEL]: "Cancel",
  [K.NO_SEARCH_RESULT]: "No search results",
  [K.ADD]: "Add",
  [K.PLEASE_ADD_SERVICE_NODE]: "Please add service node",
  [K.NOTICE]: "Notice",
  [K.WARNING]: "Warning",
  [K.URGENT]: "Urgent",
  [K.DATASOURCE_EMPTY_ERROR]: 'Parameter "dataSource" is empty',
  [K.DELETE_CONFIRM_MESSAGE]: "Are you sure you want to delete <1>{{name}}</1>?",
  [K.DELETE_CONFIRM_DETAIL]: "This deletion will erase all related data. Please confirm and enter <1>{{name}}</1> below to unlock the confirm button.",
  [K.DELETE_CONFIRM_INPUT_HINT]: "Please enter {{name}}",
};

export default locale;
